import React from 'react';

function TickMark({ ...props }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="19"
            viewBox="0 0 16 19"
            fill="none"
            {...props}
        >
            <path
                d="M0.5 4.41153V11.6196C0.5 11.7179 0.534091 11.8162 0.568182 11.8817C0.670454 12.0783 2.78409 16.4031 7.72727 18.4345C7.82955 18.4672 7.89773 18.5 8 18.5C8.10227 18.5 8.17045 18.4672 8.27273 18.4345C13.2159 16.4031 15.3636 12.0783 15.4318 11.8817C15.4659 11.7834 15.5 11.7179 15.5 11.6196V4.41153C15.5 4.11665 15.2955 3.85454 14.9886 3.78901C12.3977 3.1665 8.40909 0.643681 8.375 0.610917C8.13636 0.479862 7.86364 0.447098 7.625 0.610917C7.59091 0.643681 3.60227 3.1665 1.01136 3.78901C0.704545 3.85454 0.5 4.11665 0.5 4.41153ZM1.86364 4.90299C4.14773 4.21495 6.97727 2.54399 8 1.92147C9.02273 2.54399 11.8523 4.21495 14.1364 4.90299V11.4558C13.7614 12.1438 11.8523 15.4202 8 17.1239C4.14773 15.4202 2.23864 12.1438 1.86364 11.4558V4.90299Z"
                fill="currentColor"
            />
            <path
                d="M6.84091 11.7507C6.97727 11.8817 7.14773 11.9472 7.31818 11.9472C7.48864 11.9472 7.65909 11.8817 7.79545 11.7507L11.1705 8.50704C11.4432 8.24493 11.4432 7.85176 11.1705 7.58965C10.8977 7.32754 10.4886 7.32754 10.2159 7.58965L7.31818 10.3746L5.78409 8.90021C5.51136 8.63809 5.10227 8.63809 4.82955 8.90021C4.55682 9.16232 4.55682 9.55548 4.82955 9.81759L6.84091 11.7507Z"
                fill="currentColor"
            />
        </svg>
    );
}

export default TickMark;
